import { motion } from "framer-motion";
import { MapPin, Train, Car } from "lucide-react";

const venues = [
  {
    id: "london",
    name: "London",
    address: "De Morgan House, Russell Square, London",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_mhfa-course-hub/artifacts/x0y3dc1d_fit-900-600%3B29725-tin-room.jpg.webp",
    details: [
      { icon: Train, text: "2 minute walk from Russell Square Tube (Piccadilly Line)" },
      { icon: MapPin, text: "Central Bloomsbury — moments from Kings Cross & Euston" },
    ],
  },
  {
    id: "stevenage",
    name: "Stevenage",
    address: "The Business & Technology Centre, Bessemer Drive, Stevenage",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_mhfa-course-hub/artifacts/hmnqphgs_mantle-space-kings-court-stevenage-0003_wide.jpg",
    details: [
      { icon: Train, text: "10–15 minute walk from Stevenage Train Station" },
      { icon: Car, text: "Close to A1(M), free parking & on-site café" },
    ],
  },
];

export default function Venues() {
  return (
    <section data-testid="venues-section" className="section relative bg-[#F3EFEA]">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 items-end">
          <div className="md:col-span-7">
            <p className="eyebrow mb-4">Where we teach</p>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.02] tracking-tight text-[#1E2A25]">
              Our <span className="italic text-[#4A5D52]">classroom venues</span>.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 text-[#4A5D52] leading-relaxed">
            Warm, well-connected spaces chosen for calm learning.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {venues.map((v, i) => (
            <motion.article
              key={v.id}
              data-testid={`venue-${v.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="group bg-[#FDFBF7] rounded-3xl overflow-hidden border border-[#8DA399]/25"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={v.image}
                  alt={`${v.name} venue`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-8 md:p-10">
                <p className="eyebrow text-[#D88C76] mb-3">{v.name} Venue</p>
                <h3 className="font-serif-display text-2xl md:text-3xl text-[#1E2A25] leading-snug">{v.address}</h3>
                <ul className="mt-6 space-y-3">
                  {v.details.map((d, idx) => {
                    const Icon = d.icon;
                    return (
                      <li key={idx} className="flex items-start gap-3 text-[#4A5D52]">
                        <Icon className="w-4 h-4 mt-1 text-[#4A5D52] flex-shrink-0" strokeWidth={1.6} />
                        <span>{d.text}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
